import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=961dd05e"
import script from "./menu-list.vue?vue&type=script&lang=ts"
export * from "./menu-list.vue?vue&type=script&lang=ts"
import style0 from "./menu-list.vue?vue&type=style&index=0&id=961dd05e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports